var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLighthouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-aa4a9cd0": "",
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 34.6763,25.5954 c -0.2217,2.2466 -1.0146,3.2831 -2.3774,4.9288 l 5.0889,5.0788 -1.7122,1.7088 -5.0889,-5.0788 c -1.7122,1.36 -3.6616,2.1682 -5.8496,2.4203 v 7.1671 H 22.3597 V 34.6533 C 20.1409,34.3998 18.1901,33.593 16.5101,32.233 L 11.4184,37.3131 9.7062297,35.6044 14.7951,30.5256 C 14.0976,29.7035 13.5587,28.8014 13.1784,27.8196 12.798,26.8391 12.5286,25.7943 12.37,24.6863 H 5.18854 V 22.3137 H 12.37 c 0.1586,-1.108 0.428,-2.136 0.8084,-3.0857 0.3803,-0.9804 0.9192,-1.8992 1.6167,-2.7536 L 9.7062297,11.3956 11.4184,9.6868997 16.5073,14.7656 c 1.6491,-1.36 3.5985,-2.1514 5.8496,-2.3727 V 5.17818 h 2.3774 v 7.21472 c 2.2189,0.2535 4.1697,1.0449 5.8496,2.3727 L 35.6728,9.6868997 37.385,11.3956 32.2961,16.4744 c 1.3627,1.6765 2.1557,2.7144 2.3774,4.9288 H 46.9972 C 45.9376,9.4080997 35.844,0 23.547,0 10.5427,0 0,10.5216 0,23.5 0,36.4784 10.5427,47 23.547,47 35.844,47 45.9376,37.5919 47,25.5954 Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 28.4722,28.4638 c -1.381,1.3783 -3.0398,2.0688 -4.9738,2.0674 -1.9339,0 -3.5914,-0.6891 -4.9738,-2.0674 -1.381,-1.3782 -2.0729,-3.0338 -2.0715,-4.9638 0,-1.9301 0.6905,-3.5843 2.0715,-4.9639 1.381,-1.3783 3.0567,-2.0506 5.0257,-2.017 1.934,0 3.5746,0.6724 4.9219,2.017 1.381,1.3782 2.0729,3.0338 2.0715,4.9639 0.0014,1.93 -0.6905,3.5842 -2.0715,4.9638 z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLighthouse);
export default __webpack_public_path__ + "static/media/lighthouse.429c4ac4655c5e1203afc7e51cd7794e.svg";
export { ForwardRef as ReactComponent };